<template>
  <el-dialog
    :title="this.groupStaffId === null ? '新增人员' : '编辑人员'"
    :visible.sync="dialogFormVisible"
    custom-class="custom_dialog"
    :close-on-click-modal="false"
    top="10vh"
  >
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form
          :model="userForm"
          :rules="userFormRules"
          ref="userForm"
          label-width="110px"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'left'"
        >
          <el-form-item label="姓名：" prop="UserName">
            <el-input
              v-model="userForm.UserName"
              autocomplete="off"
              placeholder="请输入人员姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名：" prop="Phone">
            <el-input
              v-model="userForm.Phone"
              autocomplete="off"
              placeholder="建议使用手机号作为用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="Password">
            <el-input
              v-model="userForm.Password"
              autocomplete="off"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="显示顺序：">
            <el-col :span="16">
              <el-form-item class="el-form-item-internal" prop="Sort">
                <el-input
                  v-model="userForm.Sort"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :max="1000000"
                  autocomplete="off"
                  placeholder="请输入排序序号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-divider>
            <el-link
              type="primary"
              :underline="false"
              @click="showMoreField = !showMoreField"
            >
              高级配置
              <i
                class="el-icon-d-arrow-right"
                :style="
                  this.showMoreField
                    ? 'transform: rotate(-90deg);transition: all .5s'
                    : 'transform: rotate(90deg);transition: all .5s'
                "
              ></i>
            </el-link>
          </el-divider>
          <br />
          <el-form-item
            label="角色："
            prop="RoleId"
            v-show="showMoreField && false"
          >
            <el-select v-model="userForm.RoleId" @change="$forceUpdate()">
              <el-option
                v-for="item in roles"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="权重："
            prop="UserVoteNumber"
            v-show="showMoreField"
          >
            <el-input-number
              v-model="userForm.UserVoteNumber"
              :step="1"
              :precision="4"
              :controls="false"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="用户头像："
            prop="Icon"
            v-show="showMoreField && IsShowHeadPicture"
          >
            <el-upload
              class="avatar-uploader"
              :headers="uploadHeaders"
              action="/api/VoteUser/UploadHeadPicture"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="editVoteUser('userForm')"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import voteUserApi from '../../api/vote/voteUser'
export default {
  name: 'EditUser',
  data () {
    const validateSort = (rule, value, callback) => {
      if (value >= 1000000) {
        callback(new Error('排序值必须小于7位数！'))
      } else {
        callback()
      }
    }
    return {
      userForm: {
        UserId: null,
        UserName: null,
        Phone: null,
        Icon: null,
        GroupStaffID: null,
        MeetingGroupID: null,
        UserVoteNumber: null,
        RoleId: 0,
        Password: null,
        Sort: null,
        MeetingID: null
      },
      userFormRules: {
        UserName: [
          { required: true, message: '请输入人员名称', trigger: 'blur' },
          { min: 1, max: 20, message: '名称长度最多20个字符。', trigger: 'blur' }],
        Phone: [
          { required: true, message: '请输入人员账号或手机号', trigger: 'blur' },
          { min: 1, max: 50, message: '账号或手机号长度最多50个字符。', trigger: 'blur' }],
        Icon: [
          { min: 0, max: 255, message: '头像地址过长', trigger: 'blur' }],
        UserVoteNumber: [
          { required: true, message: '请输入权重', trigger: 'blur' }],
        Password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 1, max: 255, message: '密码长度最多255个字符。', trigger: 'blur' }],
        Sort: [
          { validator: validateSort, trigger: 'blur' }]
      },
      dialogFormVisible: false,
      groupStaffId: null,
      roles: [{
        value: 0,
        label: '评委'
      }, {
        value: 2,
        label: '主持人（仅用于投屏投票）'
      }],
      uploadHeaders: {
        Authorization: null
      },
      imageUrl: '',
      showMoreField: true
    }
  },
  props: {
    MeetingGroupID: { type: String },
    MeetingID: { type: String },
    IsShowHeadPicture: { type: Boolean },
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    getVoteUser: function () {
      voteUserApi.getVoteUser({
        groupStaffId: this.groupStaffId
      }).then(data => {
        this.userForm = data
        this.imageUrl = this.userForm.Icon
        this.userForm.MeetingID = this.MeetingID
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    editVoteUser: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.openLoading('保存中…')
          this.userForm.Icon = this.imageUrl
          voteUserApi.editVoteUser(this.userForm).then(data => {
            this.openLoading().close()
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            this.dialogFormVisible = false
            this.fatherSubmitDialog()
          }).catch(err => {
            this.openLoading().close()
            this.dialogFormVisible = false
            this.fatherSubmitDialog()
            return err
          })
        } else {
          return false
        }
      })
    },
    openEditUser: function (groupStaffId) {
      this.openLoading()
      this.dialogFormVisible = true
      this.groupStaffId = groupStaffId
      const state = JSON.parse(window.localStorage.getItem('state'))
      this.uploadHeaders.Authorization = 'Bearer ' + state.token
      this.imageUrl = ''
      this.showMoreField = true
      if (!groupStaffId) {
        this.userForm = {}
        this.userForm.MeetingGroupID = this.MeetingGroupID
        this.userForm.MeetingID = this.MeetingID
        this.userForm.RoleId = 0
        this.userForm.UserVoteNumber = 1
        this.openLoading().close()
      } else {
        this.getVoteUser()
      }
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = res
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '上传头像图片只能是 JPG 格式！',
          customClass: 'custom_message'
        })
      }
      if (!isLt2M) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '上传头像图片大小不能超过 2MB！',
          customClass: 'custom_message'
        })
      }
      return isJPG && isLt2M
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
